import React from 'react';
import vid2 from "../Assets/videos/3d_scanning_banner_video.mp4";
import aboutimg from "../Assets/hhg_imgs/39_1.webp"
import '../Assets/css/Scanning.css'

import faCube from "../Assets/icon/scan blue.png";
import  faPrint from "../Assets/icon/printing blue.png";
import faDraftingCompass from "../Assets/icon/design blue.png";

const Scanning = () => {
  return (
     <div class="page-template page-template-elementor_header_footer page page-id-1050 jkit-color-scheme elementor-default elementor-template-full-width elementor-kit-3 elementor-page elementor-page-1050">
      <div id="page" class="jkit-template  site">
        <div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
          <div data-elementor-type="wp-page" data-elementor-id="1050" class="elementor elementor-1050">
          <div class="elementor-element elementor-element-bdbb4a9 e-flex e-con-boxed e-con e-parent" data-id="bdbb4a9" data-element_type="container" data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true">
              <div class="e-con-inner">
                <div class="elementor-element elementor-element-2d2b035 e-con-full e-flex e-con e-child" data-id="2d2b035" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                  <div class="elementor-element elementor-element-30e7754 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-heading" data-id="30e7754" data-element_type="widget" data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="heading.default">
                    {/* <div class="elementor-widget-container">
                      <h5 class="elementor-heading-title elementor-size-default"></h5>		
                    </div> */}
                  </div>
                  <div class="elementor-element elementor-element-641798f elementor-widget__width-initial elementor-widget-mobile__width-inherit elementor-invisible elementor-widget elementor-widget-jkit_animated_text" data-id="641798f" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:200,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="jkit_animated_text.default">
                    <div class="elementor-widget-container">
                      <div  class="jeg-elementor-kit jkit-animated-text jeg_module_1050_2_676b7a2b716bd"  data-style="highlighted" data-text="Revolution" data-shape="underline">
                        <h1 class="animated-text">
                        <span class="dynamic-wrapper style-color">
                            <span class="dynamic-text">3D-</span>
                       <br></br>
                          </span>
                          <span class="normal-text style-color">Scanning
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 150" preserveAspectRatio="none">
                              <path class="style-color"  d="M3,77.5s200.54-11,493,0" transform="translate(-2.75 -68.11)"/>
                            </svg>
                          </span>
                          
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div class="elementor-element elementor-element-12b1148 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-text-editor" data-id="12b1148" data-element_type="widget" data-settings="{&quot;_animation_delay&quot;:300,&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="text-editor.default">
                  <div class="dynamic-text">
                Scanning/Reverse Engineering
								</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="elementor-element elementor-element-a5863ef e-flex e-con-boxed e-con e-parent" data-id="a5863ef" data-element_type="container" data-settings='{"content_width":"boxed"}' data-core-v316-plus="true">
            <div className="e-con-inner">
        <div className="elementor-element elementor-element-c30c61e e-flex e-con-boxed e-con e-child" data-id="c30c61e" data-element_type="container" data-settings='{"background_background":"classic","content_width":"boxed"}'>
            <div className="e-con-inner">
                <div className="elementor-element elementor-element-f9e7f13 e-flex e-con-boxed e-con e-child" data-id="f9e7f13" data-element_type="container" data-settings='{"content_width":"boxed"}'>
                    <div className="e-con-inner">
                        <div className="elementor-element elementor-element-e0929bb e-con-full e-flex e-con e-child" data-id="e0929bb" data-element_type="container" data-settings='{"background_background":"classic","content_width":"full"}'>
                            <video 
                                className="custom-video" 
                                autoPlay 
                                muted 
                                loop 
                                playsInline 
                                ref={(video) => { if (video) video.play(); }} // Ensuring autoplay
                            >
                                <source src={vid2} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
    <>
      {/* <div className="section-header">
        <h4 id="header3" className="d-inline">
          More Info On Our 
        </h4><br />
        <span>
        <h>3D Scanning Services</h><br />
          <span className="highlight"></span>
        </span>
      </div>
      <section className="about-section">
        <div id="aboutUs">
          <img src={aboutimg} alt="line art" className="about-image" />
          <div>
            <p>
              3D scanning is the process of digitizing a physical object into three-dimensional space. The resulting
              .pj3, .asc, .igs, .txt, .mk2, .umk, .stl, .ply, .obj file format contains a digital blueprint with
              geometric coordinate positions. This resulting digital twin unlocks many digital engineering
              capabilities, including reverse engineering and inspection for dimensional analysis.
            </p>
            <div id="aboutUs" className="stats-grid">
              <div>
                <h5 className="highlight">0.020mm</h5>
                <p>Accuracy</p>
              </div>
              <div>
                <h5 className="highlight">1,250,000</h5>
                <p>Scans per second</p>
              </div>
              <div>
                <h5 className="highlight">Compact</h5>
                <p>Design</p>
              </div>
              <div>
                <h5 className="highlight">Single Hand</h5>
                <p>Control</p>
              </div>
              <div>
                <h5 className="highlight">0.57 kg</h5>
                <p>in Weight</p>
              </div>
              <div>
                <h5 className="highlight">Full Metal</h5>
                <p>Scanner Body</p>
              </div>
            </div>
          </div>
        </div>
      </section>
       */}
<div class="elementor-element elementor-element-3fd02d5 e-flex e-con-boxed e-con e-parent" data-id="3fd02d5" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;boxed&quot;}" data-core-v316-plus="true" style={{ paddingTop: '10px' }}   >
                    <div class="e-con-inner">
        <div class="elementor-element elementor-element-836cbbe e-con-full e-flex e-con e-child" data-id="836cbbe" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
        <div class="elementor-element elementor-element-b29317c e-con-full e-flex e-con e-child" data-id="b29317c" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
                <div class="elementor-element elementor-element-d400f8d elementor-widget__width-inherit elementor-widget elementor-widget-heading" data-id="d400f8d" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
            <h5 class="elementor-heading-title elementor-size-default">   More Info On Our  </h5>       </div>
                </div>
                <div class="elementor-element elementor-element-93b6ef8 elementor-widget__width-initial elementor-widget-tablet__width-initial elementor-widget elementor-widget-jkit_heading" data-id="93b6ef8" data-element_type="widget" data-widget_type="jkit_heading.default">
                <div class="elementor-widget-container">
            <div  class="jeg-elementor-kit jkit-heading  align-left align-tablet- align-mobile- jeg_module_1050_4_676b7a2b79e09" ><div class="heading-section-title  display-inline-block"><h4 class="heading-title"><span class="style-color"><span>3D Scanning Services</span></span></h4></div></div>       </div>
                </div>
                <div class="elementor-element elementor-element-dd3e9a5 elementor-widget__width-initial elementor-widget elementor-widget-text-editor" data-id="dd3e9a5" data-element_type="widget" data-widget_type="text-editor.default">
                <div class="elementor-widget-container">
                3D scanning is the process of digitizing a physical object into three-dimensional space. The resulting
              .pj3, .asc, .igs, .txt, .mk2, .umk, .stl, .ply, .obj file format contains a digital blueprint with
              geometric coordinate positions. This resulting digital twin unlocks many digital engineering
              capabilities, including reverse engineering and inspection for dimensional analysis.
 
</div>
                </div>
                </div>
                <div class="elementor-element elementor-element-9ee2b7b e-con-full e-flex e-con e-child" data-id="9ee2b7b" data-element_type="container" data-settings="{&quot;content_width&quot;:&quot;full&quot;}">
    <div class="elementor-element elementor-element-6f785b5 elementor-widget elementor-widget-image" data-id="6f785b5" data-element_type="widget" data-widget_type="image.default">
        <div class="elementor-widget-container">
            <figure class="elementor-image">
                <img decoding="async" src={aboutimg} alt="Robotic Arm modern industrial technology. Industrial robots production" style={{ borderRadius: '20px' }} />
            </figure>
        </div>
    </div>
</div>
 
                </div>
                    </div>
                </div>
    </>
 
    <section className="process-selection">
      <h1>Ease Of process selection</h1>
     <table class="table table-bordered w-50">
        <thead>
            <tr>
                <th scope="col">SERVICE NAME</th>
                <th scope="col">DESCRIPTION</th>
                <th scope="col">WHAT TO PROVIDE?</th>
                <th scope="col">WHAT DO YOU GET?</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <th scope="row">SCAN-TO-CAD COMPARISON</th>
                <td>Compare your physical object to the CAD data. Can be used for a variety of purposes for inspection</td>
                <td>- Physical model <br/> - CAD file (format accepted: .IGS, .STP)</td>
                <td>1. Report Format: .pdf <br/> Client needs to identify if specific points of model should show a dimension</td>
            </tr>
            <tr>
                <th scope="row">SCAN-TO-PRINT</th>
                <td>Replicate your object in one of our 3D printing materials</td>
                <td>- Physical model</td>
                <td>1. File Format: STL <br/> 2. Printed part</td>
            </tr>
            <tr>
                <th scope="row">REVERSE ENGINEERING</th>
                <td>Obtain a modifiable file from your physical object</td>
                <td>- Physical model</td>
                <td>1. File Format: STL, STP, .IGS, (.SLDPRT or .CATPart)</td>
            </tr>
            <tr>
                <th scope="row">REVERSE ENGINEERING + DESIGN</th>
                <td>Obtain a modified (modifications made by Axis) file from your physical object</td>
                <td>- Physical model <br/> - Instructions for Design modifications</td>
                <td>1. File Format: STL, STP, .IGS, (.SLDPRT or .CATPart)</td>
            </tr>
        </tbody>
    </table>


 
    <section className="about-us">
  <h2 className="title">
    <span className="highlight">Beyond 3D Printing</span>
  </h2><br></br>
  <p className="feature-list-content1">
    At our company, we go beyond 3D printing to provide a comprehensive range of services.
    Whether it’s scanning, design consultation, or finishing touches, our skilled technicians
    are dedicated to pushing the boundaries and ensuring your ideas achieve their full potential.
    Let us take your project to the next level.
  </p><br></br>
  <div className="icons">
        <div className="icon-item">
          <img src={faCube} className="icon" />
          <span>3D SCAN</span>
        </div>
        <div className="icon-item">
          <img src={faPrint} className="icon" />
          <span>3D PRINT</span>
        </div>
        <div className="icon-item">
          <img src={faDraftingCompass} className="icon" />
          <span >3D DESIGN</span>
        </div>
      </div>
</section>

<section className="services">
  <h2>Empower Your Journey With Credible Advisors</h2><br></br>
  <p className="feature-list-content1">
    We provide high-quality parts with a guarantee. Our 3D print services prioritize accuracy
    and quality, ensuring meticulous attention to your requests.
  </p>
  
  <div className="process-flow">
    {/* You can add your process steps here */}
  </div>
  
  {/* <div className="button-group">
    <button className="btn-modern btn-primary">Talk To Expert</button>
    <button className="btn-modern btn-secondary">Design/Scanning Quote</button>
    <button className="btn-modern btn-secondary">3D Print Quote</button>
  </div> */}
</section>
{/* <div class="process-container">
        <div class="process-step">
            <div class="icon-circle">
                <i class="fas fa-paper-plane"></i>
            </div>
            <span>YOU SEND</span>
        </div>
        <span class="arrow"> &gt; </span>
        <div class="process-step">
            <div class="icon-circle">
                <i class="fas fa-dollar-sign"></i>
            </div>
            <span>WE QUOTE</span>
        </div>
        <span class="arrow"> &gt; </span>
        <div class="process-step">
            <div class="icon-circle">
                <i class="fas fa-cogs"></i>
            </div>
            <span>WE BUILD</span>
        </div>
        <span class="arrow"> &gt; </span>
        <div class="process-step">
            <div class="icon-circle">
                <i class="fas fa-truck"></i>
            </div>
            <span>WE DELIVER</span>
        </div>
    </div> */}
</section>
   
  </div> 
</div>
</div>
</div>

  );
};

export default Scanning;